import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { atomWithDefault } from 'jotai/utils';

import { getFeatureHighlights } from '@flipster/apis/v1/user';
import { getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

import { authBunja } from '../../../auth/state';
import { userRegulationBunja } from '../../../regulation';
import { webviewInfoBunja } from '../../../webview';

export const featureHighlightKey = 'flipster.configs.v1.featureHighlightVersion';

export const featureHighlightBunja = bunja(() => {
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const { isSpotOnlyRegulationAtom } = bunja.use(userRegulationBunja);
  const { webviewAtom } = bunja.use(webviewInfoBunja);
  const featureHighlightQueryAtom = atomWithQuery((get) => {
    const isCookieLoggedIn = get(isCookieLoggedInAtom);

    return {
      queryKey: ['getFeatureHighlights'],
      queryFn: getFeatureHighlights,
      enabled: isCookieLoggedIn,
      staleTime: Infinity,
      cacheTime: Infinity,
    };
  });

  const featureHighlightAtom = atom((get) => get(featureHighlightQueryAtom).data?.data);

  const featureHighlightVersionBaseAtom = atomWithDefault<string | null>(() => {
    return getLocalStorage(featureHighlightKey);
  });

  const featureHighlightVersionAtom = atom(
    (get) => get(featureHighlightVersionBaseAtom),
    (_, set, version: string) => {
      setLocalStorage(featureHighlightKey, version);
      set(featureHighlightVersionBaseAtom, version);
    },
  );

  const showFeatureHighlightAtom = atom((get) => {
    const isWebview = get(webviewAtom);
    const isSpotOnlyRegulation = get(isSpotOnlyRegulationAtom);
    const featureHighlight = get(featureHighlightAtom);

    if (isWebview) return false;
    if (isSpotOnlyRegulation) return false;

    if (!featureHighlight) return false;

    const { version } = featureHighlight;
    const storedVersion = get(featureHighlightVersionAtom);

    // 저장된 버전이 없거나, 서버 버전이 더 크면 표시
    if (!storedVersion || Number(storedVersion) < (version ?? 0)) {
      return true;
    }

    return false;
  });

  const isShowAtom = atom(false);

  return {
    featureHighlightAtom,
    featureHighlightVersionAtom,
    showFeatureHighlightAtom,
    isShowAtom,
    featureHighlightQueryAtom,
  };
});
featureHighlightBunja.debugLabel = 'featureHighlightBunja';
